module.exports = __webpack_public_path__ + "static/use-case-7-content-4-d1a8d5bda07a0daf4e2a34295aad02c2.png";